import axios from 'axios';
import { backendHOST } from '../../client-config/client-config';
import setAuthToken from '../../utils/setAuthToken';

const url = `${backendHOST}/api/params/SystemSettings`;

function ensureAuthToken() {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
    return true;
  }

  return false;
}

const jsonConfig = {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
};

export async function getSystemSettings(areaCode) {
  if (!ensureAuthToken()) {
    return [];
  }

  try {
    const res = await axios.get(url, jsonConfig);

    if (res.status === 200) {
      const data = Array.isArray(res.data) ? res.data : [];

      if (!areaCode) {
        return data;
      }

      return data.filter((item) => item.SettingArea === areaCode);
    }

    return [];
  } catch (e) {
    console.error('getSystemSettings error', e);
    return [];
  }
}

export async function getAllSystemSettings() {
  return getSystemSettings();
}

export async function createSystemSetting(setting) {
  if (!ensureAuthToken()) {
    return { isOk: false };
  }

  try {
    const res = await axios.post(url, setting, jsonConfig);
    return res.data;
  } catch (e) {
    console.error('createSystemSetting error', e);
    return { isOk: false };
  }
}

export async function updateSystemSetting(key, setting) {
  if (!ensureAuthToken()) {
    return { isOk: false };
  }

  try {
    const res = await axios.put(
      url,
      {
        key,
        values: JSON.stringify({
          SettingValue: setting.SettingValue,
        }),
      },
      jsonConfig,
    );

    return res.data;
  } catch (e) {
    console.error('updateSystemSetting error', e);
    return { isOk: false };
  }
}

export async function deleteSystemSetting(key) {
  if (!ensureAuthToken()) {
    return { isOk: false };
  }

  try {
    const res = await axios.delete(url, {
      ...jsonConfig,
      data: {
        key,
      },
    });

    return res.data;
  } catch (e) {
    console.error('deleteSystemSetting error', e);
    return { isOk: false };
  }
}
